export default __webpack_public_path__ + "static/x-9e5f99f4079001be12f35fd37b03352e.ico";